import { Link } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";

export default function NotFoundPage() {
  useDocumentTitle("Page not found");

  return (
    <div className="empty-state">
      <div className="empty-icon">🧭</div>
      <h3>Page not found</h3>
      <p>The page you are looking for does not exist or has moved.</p>
      <Link to="/" className="empty-cta">Go Home</Link>
    </div>
  );
}
